import { authority } from "../shared/security/authority";

const routes = [
  {
    path: "/payrolls",
    component: () => import("../views/Payrolls.vue"),
    meta: {
      authorities: [
        authority.EMPLOYEE.role,
      ]
    }
  },
  {
    path: "/payrollDetail/:id",
    name: "payrollDetail",
    component: () => import("../views/PayrollDetail.vue"),
    meta: {
      authorities: [
        authority.EMPLOYEE.role,
      ]
    }
  },
  {
    path: "/mydata",
    component: () => import("../views/Profile.vue"),
    meta: {
      authorities: [
        authority.EMPLOYEE.role,
      ]
    }
  },
  {
    path: "/documents",
    component: () => import("../views/Documents/Documents.vue"),
    meta: {
      authorities: [
        authority.EMPLOYEE.role,
      ]
    }
  },
  {
    path: "/cuds",
    component: () => import("../views/Cuds.vue"),
    meta: {
      authorities: [
        authority.EMPLOYEE.role,
      ]
    }
  },
  {
    path: "/mynotices",
    component: () => import("../views/MyNotices.vue"),
    meta: {
      authorities: [
        authority.EMPLOYEE.role,
      ]
    }
  },
  {
    path: "/myrequests",
    component: () => import("../views/MyRequests.vue"),
    meta: {
      authorities: [
        authority.EMPLOYEE.role,
      ]
    }
  },
];

export default routes;
